export const getIcon = nameIcon =>
  require(`@/assets/icons/navbar/${nameIcon}.svg`);
